import React, { useState, useEffect } from 'react';
import { Settings } from 'lucide-react';
import AdminService from '../../services/admin.service';

const InactiveTherapistsView = () => {
    const [inactiveTherapists, setInactiveTherapists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadInactiveTherapists();
    }, []);

    const loadInactiveTherapists = async () => {
        try {
            setLoading(true);
            const data = await AdminService.getInactiveTherapists();
            setInactiveTherapists(data.therapists);
        } catch (error) {
            setError('Errore nel caricamento dei dottori inattivi');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div>Caricamento...</div>;
    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold flex items-center">
                    <Settings className="w-5 h-5 mr-2 text-yellow-600" />
                    Dottori Inattivi
                </h2>
                <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                    {inactiveTherapists.length} inattivi
                </span>
            </div>
            <div className="space-y-4">
                {inactiveTherapists.map((therapist) => (
                    <div key={therapist.id} className="border-b last:border-0 pb-3 last:pb-0">
                        <div className="flex justify-between items-center">
                            <div>
                                <p className="font-medium">
                                    {therapist.user.first_name} {therapist.user.last_name}
                                </p>
                                <p className="text-sm text-gray-600">
                                    {therapist.specialization}
                                </p>
                            </div>
                            <button 
                                className="px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700"
                                onClick={() => {/* Aggiungi qui la logica per la verifica */}}
                            >
                                Verifica
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InactiveTherapistsView;